import React from "react";
import { FaTruck } from "react-icons/fa";

const OffSiteDeliveryMenuItem = (name: string) => {
    return [
        <FaTruck key={`${name}-icon`} size={"1.5em"} />,
        <div key={`${name}-text`}>
            <span>{name}</span>
        </div>,
    ];
};

export default OffSiteDeliveryMenuItem;
